export { default } from './AdventurerForm';



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Adventurer/AdventurerForm/index.js